(function($) {

  try {

    $(".look-inside-popup-wrapper").hide();
    $(".look-inside-popup").addClass('look-inside-popup--loaded');

    $(".openpop").click(function (e) {
      e.preventDefault();
      $(".look-inside-popup-wrapper").addClass('look-inside-popup-wrapper--loaded');
      $('body').toggleClass('look-inside-popup--open');
      $("#look-inside-iframe").attr("src", $(this).attr('href'));
      $(".look-inside-popup-wrapper").css("display", "flex")
      .hide()
      .fadeIn('slow');
    });

    $(".look-inside-popup__close").click(function(e) {
      e.preventDefault();
      $('body').toggleClass('look-inside-popup--open');
      $(".look-inside-popup-wrapper").hide();
      $(".look-inside-popup-wrapper").removeClass('look-inside-popup-wrapper--loaded');
    });
  } 
  catch(e) { 
    console.error(e); 
  }
})(jQuery);